module.exports = __webpack_public_path__ + "img/alegria.f3d788f9.gif";